/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Cristia David Lemus Calderón                               ║
║ cristian.lemus@iudigital.edu.co                            ║
╚════════════════════════════════════════════════════════════╝
*/

import { useState } from "react";
import VerifyByDocument from "../modules/VerifyByDocument";
import { getAllCardPerDocumentUser } from "../services/VerifyCarnetService";
import MDAlert from "components/Alert";

export default function VerifyCarnetController() {
  const [document, setNewData] = useState({});
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [typeAlert, setTypeAlert] = useState("");
  const [message, setMessage] = useState("");

  //ejecuta la funcion requestUpdateValidity con la información necesaria y cierra el modal de actualizar vigencia
  const handleSubmitRequest = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault(); // Previene comportamiento predeterminado del formulario
    }

    // Validar que el campo no esté vacío
    if (!document.name || document.name.trim() === "") {
      handleAlert("fail", "El número de documento no puede estar vacío.");
      return; // Detiene la ejecución
    }

    setIsLoading(true);
    try {
      const result = await getAllCardPerDocumentUser(document.name);
      if (result.status !== false) {
        await setData(result.payload);
        handleAlert("success");
      } else {
        handleAlert("fail", result.message || "Error al realizar la consulta");
      }
    } catch (error) {
      handleAlert("fail", error.message || "Error al realizar la consulta");
    } finally {
      setIsLoading(false);
    }
  };

  const handleFieldChange = (fieldName, value) => {
    setNewData({
      ...document,
      [fieldName]: value,
    });
  };

  // Maneja las alertas de exito fallo
  const handleAlert = (typeAlert, message) => {
    setTypeAlert(typeAlert);
    setMessage(message);
    setIsAlert(true);
  };

  return (
    <>
      <VerifyByDocument
        handleFieldChange={handleFieldChange}
        handleSubmit={handleSubmitRequest}
        data={data}
        isLoading={isLoading}
      ></VerifyByDocument>
      <MDAlert
        isAlert={isAlert}
        setIsAlert={setIsAlert}
        typeAlert={typeAlert}
        message={message}
      ></MDAlert>
    </>
  );
}
